<template>
    <div id="resource-add">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary" @click="saveHandler(1)" size="medium">保存</el-button>
            <el-button type="primary" @click="saveHandler(2)" size="medium">发布</el-button>
        </div>
        <div class="form-container">
            <el-form
                :model="formData"
                label-width="150px"
                :rules="rules"
                ref="form"
            >
                <el-form-item label="资源名称" prop="resourseName">
                    <div style="width: 500px;">
                        <el-input v-model="formData.resourseName" placeholder="资源名称（1-40个字符）"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="发布学校" prop="sendSchoolJson">
                    <div style="width: 500px;">
                        <el-select v-model="formData.sendSchoolJson" multiple @change="sendSchoolChangeHandler" placeholder="请选择发布学校">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option
                                v-for="item in schoolList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="发布对象" prop="sendType">
                    <el-radio :label="0"
                              v-model="formData.sendType">
                        全部
                    </el-radio>
                    <el-radio :label="1"
                              v-model="formData.sendType">
                        学生
                    </el-radio>
                    <el-radio :label="2"
                              v-model="formData.sendType">
                        教师
                    </el-radio>
                </el-form-item>
                <el-form-item label="资源封面" prop="resourceLogo">
                    <web-uploader
                        prefixPath="resourcePlatform"
                        v-model="files"
                        :multiple="false"
                        :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                        showMode="cover"
                        showResult="image"
                    >
                    </web-uploader>
                </el-form-item>
                <el-form-item label="资源视频" prop="videoUrl">
                    <uploader :extList="['mp4', 'flv']" showMode="button" @delete="deleteVideoHandler" @input="uploadVideoHandler"></uploader>
                </el-form-item>
                <el-form-item label="资源介绍" prop="introdution">
                    <ueditor class="rich-editor" ref="ueditor" :defaultMes="formData.introdution"
                             @editModel="richTextEditHandler"></ueditor>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
    import {addMoralEduOLResource, queryByPostcode} from '@/api/resourceManagement/resourceManagement';
    import Ueditor from '@/components/Ueditor';
    import baseMixin from '@/mixins/baseMixin.js';
    import Uploader from '@/components/Uploader/VideoUploader';
    import WebUploader from '@/components/Uploader/WebUploader';

    export default {
        name: "resourceAdd",
        mixins: [baseMixin],

        data() {
            return {
                files: [],

                courseId: this.$route.query.courseId,
                areaCode: this.$route.query.areaCode,
                courseLevelCode: this.$route.query.courseLevelCode,

                formData: {
                    resourseName: '',
                    resourceLogo: '',
                    resourceSize: 0,
                    introdution: '',
                    videoUrl: '',
                    videoId: 0,
                    sendSchoolJson: [],
                    sendType: 0
                },
                schoolList: [],
                schoolMapping: {},
                customCoverUrl: '',
                rules: {
                    resourseName: [{
                        required: true, message: '资源名称不能为空', trigger: 'blur'
                    }, {
                        min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur'
                    }],
                    resourceLogo: [{
                        required: true, message: '课程封面不能为空', trigger: 'blur'
                    }],
                    introdution: [{
                        required: true,
                        message: '资源介绍不能为空'
                    }],
                    videoUrl: [{
                        required: true,
                        message: '视频不能为空'
                    }],
                    sendSchoolJson: [{
                        required: true,
                        message: '发布学校不能为空'
                    }],
                    sendType: [{
                        required: true,
                        message: '发布对象不能为空'
                    }]
                }
            }
        },
        created() {
            queryByPostcode({
                postcode: this.areaCode,
                learningStages: this.courseLevelCode
            })
                .then(res => res.data)
                .then(data => {
                    this.schoolList = data.data;
                    const schoolMapping = {};
                    data.data.forEach(item => {
                        schoolMapping[item.id] = {
                            id: item.id,
                            name: item.name
                        };
                    });
                    this.schoolMapping = schoolMapping;
                });
        },
        components: {
            Ueditor,
            Uploader,
            WebUploader
        },
        methods: {
            sendSchoolChangeHandler(value) {
                if(value.indexOf(0) !== -1 && value.indexOf(0) !== 0) {
                    this.formData.sendSchoolJson = [0];
                }
                if(value.indexOf(0) === 0 && value.length !== 1) {
                    this.formData.sendSchoolJson.splice(0, 1)
                }
            },
            richTextEditHandler(introdution) {
                this.formData.introdution = introdution;
                this.$refs.form.validateField('introdution');
            },
            saveHandler(status) {
                this.formData.resourceLogo = this.files.length === 0 ? '' : this.files[0].fileUrl;
                const args = this.formData;
                this.$refs.form.validate((valid) => {
                    if(valid) {
                        args.moralType = 1001;
                        args.introdution = this.$refs.ueditor.getContent();
                        args.courseId = this.courseId;
                        args.status = status;
                        if(this.formData.sendSchoolJson[0]=== 0) {
                            args.sendSchoolJson = this.schoolList.map(item => ({
                                id: item.id,
                                name: item.name
                            }));
                        } else {
                            args.sendSchoolJson = this.formData.sendSchoolJson.map(id => this.schoolMapping[id])
                        }

                        addMoralEduOLResource(args)
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message({
                                        message: '添加资源成功',
                                        type: 'success'
                                    });
                                    this.$router.back();
                                }
                            })
                    }
                });
            },
            uploadVideoHandler(data) {
                this.formData.videoUrl = data[0].url;
                this.formData.videoId = data[0].serverFileId;
                this.formData.resourceSize = Math.floor(data[0].fileInfo.size / 1024);
                this.$refs.form.validateField('videoUrl');
            },
            deleteVideoHandler() {
                this.formData.videoUrl = '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }
    .form-container {
        margin-top: 162px;
        width: 65%;
        padding-top: 20px;
    }
    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 146px;
        vertical-align: top;
        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }
        font-size: 28px;
        color: #8c939d;
    }
    .logo-image {
        @include wh(317px, 175px);
        @include cover-bg;
    }
</style>
<style lang="scss">
    @import "../../styles/mixin";

    #resource-add {
        .upload-file-item {
            @include wh(317px, 175px);
            img {
                @include wh(317px, 175px);

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceManagement/resourceAdd.vue